import React, { useState, useEffect } from 'react';
import TopTitle from './TopTitle';
import axios from 'axios';
import { comma, uncomma } from './common'
import Pagination from "react-js-pagination";
import Bottom_menu from "./Bottom_menu";
import { formatDate } from './common';
import { instance,currentDate_j } from './common';
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
import calendar from './img/sigong_nav/month.png'
import arrow from './img/eva_arrow-ios-downward-fill.png';
function totalPrice(data,discount){
    let price = 0;
    data.forEach(function(v){
        price += Number(v.s_member_price);
        if(v.c_option){
            JSON.parse(v.c_option).forEach(function(items){
                price += Number(items.price);
            });
        }
    });
    price =  price-discount;
    return comma(price);
}



function setName(v) {
    let name = '';
    JSON.parse(v.s_id).forEach(function (items) {
        if (JSON.parse(v.s_id).length > 1) {
            name = JSON.parse(v.s_id)[0].s_name + ' 외 ' + JSON.parse(v.s_id).length + '개';
        } else {
            name = JSON.parse(v.s_id)[0].s_name;
        }
    });

    return name;
}

function priceReturn(data){
    let price = 0;
    data.forEach(function(v){
        price += Number(v.jungsan_price)
        
    });

    return comma(price);
}
function jungsanDate(year,month){
    let monthStr = '';
    if(month < 9){
        monthStr = '0'+(month+1);
    }else{
        monthStr = month+1;
    }

    return year + '.' + monthStr;
}
function LoadData({history}) {

    let now = new Date();

    const [data, setData] = useState([]);
    const [year ,setYear] = useState(now.getFullYear());
    const [month ,setMonth] = useState(now.getMonth());
    const [f_date, setf_date] = useState(new Date(year, month, 1));
    const [l_date, setl_date] = useState(new Date(year, month+1, 0));

    
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;

    let obj = {
        si_id: si_id,
        f_date:formatDate(f_date),
        l_date:formatDate(l_date)
    }
    
    const onClick = (e) => {
        const {arrow} = e.target.dataset;
     

        if(arrow === 'left'){
            if(month == 0){
                setYear(year-1);
                setMonth(11);

                setf_date(new Date(year-1, 11, 1))
                setl_date(new Date(year-1, 1, 0))
                
                
            }else{
                setMonth(month-1);
                setf_date(new Date(year, month-1, 1))
                setl_date(new Date(year, month, 0))
            }
            
        }else if(arrow === 'right'){
            if(month == 11){
                setMonth(0);
                setYear(year+1);

                setf_date(new Date(year+1, 0, 1))
                setl_date(new Date(year+1, 1, 0))

            }else{
                setMonth(month+1);

                setf_date(new Date(year, month+1, 1))
                setl_date(new Date(year, month+2, 0))


            }
            
        }

        
    }
    useEffect(() => {

        const fetchData = async () => {
            instance.post('/reserve/v2/jungsan', obj).then(function (res) {
                console.log('res : ', res);
                setData(res.data.rows);
            });

        };
        fetchData();
    }, [si_id,f_date,l_date]);

    const tabSearch = {
        whiteSpace: 'nowrap'
    }
    const grayLine = {
        border: 'solid 1px lightgray',
    }



    const ab = {
        position:'absolute',
        right:'23px',
        top:'4px',
        width:'20px'
    }

    const ab2 = {
        position:'absolute',
        right:'8px',
        top:'4px',
        width:'20px'
    }

    return (
        <>
            <div className="container">
                <div className="row p-0">
                    <div className="col-3 text-left">
                        <img src={arrow} style={{width:'24px',transform:'rotate(-90deg)',verticalAlign:'top'}} data-arrow="left" onClick={onClick}/>
                    </div>
                    <div className="col-6 text-center font-weight-bold h4 m-0" style={{lineHeight:'23px'}}>{jungsanDate(year,month)}</div>
                    <div className="col-3 text-right">
                        <img src={arrow} style={{width:'24px',transform:'rotate(90deg)'}} data-arrow="right" onClick={onClick}/>
                    </div>
                </div>
                <div className="mt-5">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="h3 font-weight-bold" style={{color:'#00479D'}}>총 매출</th>
                                <th className="h3 font-weight-bold text-right" style={{color:'#00479D'}}> {priceReturn(data,'')} 원</th>
                            </tr>
                        </thead>
                        <tbody>
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </div>
            </div>
        </>
    )
}

function progressDate(type){
    
    const d = new Date();
    let result;
    if(type === '전체'){
        result = '전체';
    }else if(type === 0){
        
        result = formatDate(d);
    }else{
        const date = new Date(d.getFullYear(), d.getMonth(), d.getDate() - type);
        result = formatDate(date);
    }    
    
    return result
}


function Jungsan({history}) {

    
    const pbottom = {
        paddingBottom : '90px'
    }
    return (
        <>
            <div style={pbottom}>
            <TopTitle title="정산관리" />
            <LoadData history={history}/>
            <Bottom_menu />            
            </div>
        </>
    )
}

export default Jungsan;